// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./icons-codes.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/app.eot?42391129", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../font/app.woff?42391129", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../font/app.ttf?42391129", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../font/app.svg?42391129", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#bpmnio" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * bpmn + custom icon definitions
 */

@font-face {
  font-family: 'app';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
}


[class^="icon-"]:before,
[class*=" icon-"]:before {
  font-style: normal;
  font-weight: normal;
  speak: none;

  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  text-align: center;

  font-variant: normal;
  text-transform: none;

  line-height: 1em;
}

[class^="icon-"]:before,
[class*=" icon-"]:before {
  font-family: "app";
}
`, "",{"version":3,"sources":["webpack://./client/css/icons.css"],"names":[],"mappings":"AAAA;;EAEE;;AAGF;EACE,kBAAkB;EAClB,4CAAoC;EACpC;;;4DAGyD;EACzD,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;;EAEX,qBAAqB;EACrB,wBAAwB;EACxB,UAAU;EACV,kBAAkB;;EAElB,oBAAoB;EACpB,oBAAoB;;EAEpB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB","sourcesContent":["/**\n * bpmn + custom icon definitions\n */\n@import \"./icons-codes.css\";\n\n@font-face {\n  font-family: 'app';\n  src: url('../font/app.eot?42391129');\n  src: url('../font/app.eot?42391129#iefix') format('embedded-opentype'),\n       url('../font/app.woff?42391129') format('woff'),\n       url('../font/app.ttf?42391129') format('truetype'),\n       url('../font/app.svg?42391129#bpmnio') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n\n[class^=\"icon-\"]:before,\n[class*=\" icon-\"]:before {\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n\n  display: inline-block;\n  text-decoration: inherit;\n  width: 1em;\n  text-align: center;\n\n  font-variant: normal;\n  text-transform: none;\n\n  line-height: 1em;\n}\n\n[class^=\"icon-\"]:before,\n[class*=\" icon-\"]:before {\n  font-family: \"app\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
